import { UserStatusEnum } from '@ztechapps/common.contract'

/**
 * Builds the shared user-search filter for the customer, vendor and contact pickers:
 * active users whose profile name, profile email or company name matches the input,
 * case-insensitively. A caller spreads its own filter after the result to narrow it.
 *
 * @param input - The raw text the user typed into the select
 * @returns A Mongo filter matching active users on name, email or company
 */
export function buildUserSearchFilter(input: string) {
  return {
    status: UserStatusEnum.active,
    $or: [
      { 'profile.name': { $regex: input, $options: 'i' } },
      { 'profile.email': { $regex: input, $options: 'i' } },
      { 'company.name': { $regex: input, $options: 'i' } },
    ],
  }
}
